import type { UrlLengthStatus } from '@lib/urlLength'

interface UrlLengthDialogContentProps {
  status: Exclude<UrlLengthStatus, 'ok'>
  formattedCurrent: string
  formattedLimit: string
  percentageUsed: number
}

const statusConfig = {
  warning: {
    barColor: 'bg-warning',
    description: 'You have many filters selected. Consider reducing them to avoid request failures.',
  },
  error: {
    barColor: 'bg-destructive-foreground',
    description:
      'Too many filters selected. The request will be rejected by the server. Remove some filters to continue.',
  },
} as const

export function UrlLengthDialogContent({
  status,
  formattedCurrent,
  formattedLimit,
  percentageUsed,
}: UrlLengthDialogContentProps) {
  const config = statusConfig[status]

  return (
    <div className='space-y-3 pt-2'>
      <div className='rounded bg-muted p-3 space-y-2'>
        <div className='flex justify-between items-center text-sm'>
          <span className='text-muted-foreground'>URL size</span>
          <span className='font-medium tabular-nums'>
            {formattedCurrent} / {formattedLimit}
          </span>
        </div>
        <div className='w-full bg-background rounded-full h-2'>
          <div
            className={`h-2 rounded-full transition-all ${config.barColor}`}
            style={{ width: `${percentageUsed}%` }}
          />
        </div>
      </div>
      <p className='text-sm text-muted-foreground'>{config.description}</p>
    </div>
  )
}
